import { Action } from '@ngrx/store';

export const UPDATE_REDUCERS_ACTION = '@ngrx/store/update-reducers';

export class LocalStorageSyncAction implements Action {
  readonly type = UPDATE_REDUCERS_ACTION;
}

export type GeneralActionsUnion = LocalStorageSyncAction;
